module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qpelv3b-b2d9bcb0adb7409ebcb1806d611fc90d.jpg";